/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TestRouteImport } from './routes/test'
import { Route as ProjekteRouteImport } from './routes/projekte'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as Ind2RouteImport } from './routes/ind2'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as ArchitectureRouteImport } from './routes/architecture'
import { Route as IndexRouteImport } from './routes/index'

const TestRoute = TestRouteImport.update({
  id: '/test',
  path: '/test',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjekteRoute = ProjekteRouteImport.update({
  id: '/projekte',
  path: '/projekte',
  getParentRoute: () => rootRouteImport,
} as any)
const KontaktRoute = KontaktRouteImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => rootRouteImport,
} as any)
const Ind2Route = Ind2RouteImport.update({
  id: '/ind2',
  path: '/ind2',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchitectureRoute = ArchitectureRouteImport.update({
  id: '/architecture',
  path: '/architecture',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/architecture': typeof ArchitectureRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/ind2': typeof Ind2Route
  '/kontakt': typeof KontaktRoute
  '/projekte': typeof ProjekteRoute
  '/test': typeof TestRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/architecture': typeof ArchitectureRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/ind2': typeof Ind2Route
  '/kontakt': typeof KontaktRoute
  '/projekte': typeof ProjekteRoute
  '/test': typeof TestRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/architecture': typeof ArchitectureRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/ind2': typeof Ind2Route
  '/kontakt': typeof KontaktRoute
  '/projekte': typeof ProjekteRoute
  '/test': typeof TestRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/architecture'
    | '/datenschutz'
    | '/impressum'
    | '/ind2'
    | '/kontakt'
    | '/projekte'
    | '/test'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/architecture'
    | '/datenschutz'
    | '/impressum'
    | '/ind2'
    | '/kontakt'
    | '/projekte'
    | '/test'
  id:
    | '__root__'
    | '/'
    | '/architecture'
    | '/datenschutz'
    | '/impressum'
    | '/ind2'
    | '/kontakt'
    | '/projekte'
    | '/test'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArchitectureRoute: typeof ArchitectureRoute
  DatenschutzRoute: typeof DatenschutzRoute
  ImpressumRoute: typeof ImpressumRoute
  Ind2Route: typeof Ind2Route
  KontaktRoute: typeof KontaktRoute
  ProjekteRoute: typeof ProjekteRoute
  TestRoute: typeof TestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test': {
      id: '/test'
      path: '/test'
      fullPath: '/test'
      preLoaderRoute: typeof TestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projekte': {
      id: '/projekte'
      path: '/projekte'
      fullPath: '/projekte'
      preLoaderRoute: typeof ProjekteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kontakt': {
      id: '/kontakt'
      path: '/kontakt'
      fullPath: '/kontakt'
      preLoaderRoute: typeof KontaktRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ind2': {
      id: '/ind2'
      path: '/ind2'
      fullPath: '/ind2'
      preLoaderRoute: typeof Ind2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/architecture': {
      id: '/architecture'
      path: '/architecture'
      fullPath: '/architecture'
      preLoaderRoute: typeof ArchitectureRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArchitectureRoute: ArchitectureRoute,
  DatenschutzRoute: DatenschutzRoute,
  ImpressumRoute: ImpressumRoute,
  Ind2Route: Ind2Route,
  KontaktRoute: KontaktRoute,
  ProjekteRoute: ProjekteRoute,
  TestRoute: TestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
